// @flow
import type { AppState } from 'modules/rootReducer';
import type { LocationType } from 'types/common';

const getUserLocation = (state: AppState): Object<LocationType> | null => {
  return state.location.location;
};

const getUserLocationLoading = (state: AppState): boolean => {
  return state.location.loading.location;
};

const getUserLocationError = (state: AppState): string | null => {
  return state.location.error.location;
};

export const LocationSelector = {
  getUserLocation,
  getUserLocationLoading,
  getUserLocationError,
};
